import './Footer.css'

const Footer = () => (
  <footer className='footer'>
      Created by Me - {new Date().getFullYear()}
  </footer>
)

export default Footer
